import { useIntl } from 'react-intl';
import MarketingLayout from '@/Components/Marketing/MarketingLayout';
import BuiltForBatteries from '@/Components/Marketing/Welcome/BuiltForBatteries';
import Consulting from '@/Components/Marketing/Welcome/Consulting';
import Hero from '@/Components/Marketing/Welcome/Hero';
import PartnerProgram from '@/Components/Marketing/Welcome/PartnerProgram';
import Partners from '@/Components/Marketing/Welcome/Partners';
import PassportScan from '@/Components/Marketing/Welcome/PassportScan';
import PlatformBento from '@/Components/Marketing/Welcome/PlatformBento';
import ResourcesHub from '@/Components/Marketing/Welcome/ResourcesHub';

/**
 * Home (`/`). A passport platform for any product, with batteries as the
 * first passports to apply and the worked example throughout, and the rest
 * of Synex beside it (2026-10-04: about half and half): under the logo
 * strip, the consulting division and how we set a team up on the platform
 * (ruling C-11's place; the pinned regulation story that stood between them
 * was dropped on 2026-10-05); after the platform's bento, how products are
 * built (the sector phones that stood between them went on 2026-10-05);
 * then the partner program and the resources; and it ends on the example passport: its code
 * and the way to it beside "Book a demo". The resources hold the page's
 * newsletter sign-up (2026-10-05), so the footer leaves out its own.
 *
 * The sections live in Components/Marketing/Welcome, not in a Sections/
 * folder beside this page: every .jsx under Pages/ is an entry of app.jsx's
 * page glob, and as entries of their own they split Home's chunks (R60; the
 * move took Home from 107 files to 87, Task 10b-3).
 *
 * `canRegister` is part of the page's props contract (registration is
 * disabled, and RegistrationDisabledTest pins that the page renders with
 * `canRegister=false`); nothing on the page offers sign-up.
 */
export default function Welcome({ canLogin, canRegister }) {
    const { formatMessage } = useIntl();

    return (
        <MarketingLayout title={formatMessage({ id: 'site.home.meta.title' })} canLogin={canLogin} footerNewsletter={false}>
            <Hero />
            <Partners />
            <Consulting />
            <PlatformBento />
            <BuiltForBatteries />
            <PartnerProgram />
            <ResourcesHub />
            <PassportScan />
        </MarketingLayout>
    );
}
